<template>
    <div class="results-box">
        <h1>Scope of Framing</h1>
        <medal-two :medalType="label" />
        <p v-html="desc"></p>
    </div>
</template>
<script>
    import { mapGetters, mapActions } from "vuex"
    import Medal2 from '@/components/Medal2.vue'
    
    export default{
        name : "ScopeRibbonFeedback",
        components: {
            'medal-two' : Medal2,
        },
        data(){
            return {
                rbn : "",
                desc : "",
                overview : "",
                label: ""
            }
        },
        mounted(){
            this.setRibbon()
            // TODO: add text to JSON
        },
        computed : {
            ...mapGetters([
                "playerTotal",
                "getScoring",
                "getScopeResult"
            ])
        },
        methods : {
            setRibbon(){
                const cat     = this.getScopeResult
                const content = this.getScoring.scope.options[ cat ]

                this.rbn   = content.source
                this.label = content.label
                this.desc  = content.description
            }
        }
    }
</script>